import $ from 'jquery';
import _ from 'lodash';
import Backbone from 'backbone';
import config from 'config';
import utility from '../../../helpers/utility';
import appOptions from '../../../helpers/appOptions';
import travelerFeeHelper from '../../../helpers/travelerFee';
import storage from '../../../helpers/storage';
import constants from '../../../helpers/constants';
import analytics from '../../../helpers/analytics';
import nativeUtility from '../../../helpers/nativeUtility';
import checkoutConfig from '../../../helpers/config';
import vasHelper from '../../../helpers/vas';
import cardType from '../../../helpers/card-type';
import {ckoApiCreateVasCheckout} from '../../../helpers/endpoints';
import egtnlUtil from '../../../helpers/egtnl-util';

const checkoutModel = Backbone.Model.extend({
    defaults: {
        quote: {},
        insurtechRequest: null,
        totalPriceWithoutInsurance: 0,
        toastMessage: {
            message: '',
            dismissible: false,
        },
        agentAssist: {},
        guestSelector: {
            numAdults: 0,
            numChildren: 0,
            numInfants: 0,
            petIncluded: false,
        },
        messageToOwner: {
            message: null,
        },
        propertyDetailsAnalytics: {
            item1: '-1',
            item2: '-1',
            item3: '-1',
            item4: '-1',
        },
        shouldRenderPayment: true, // set to True to render payment; set to False to render just the header

        // TODO scrollError default true or false ?
        expirationDate: '',
        firstName: '',
        lastName: '',
        paymentTabType: null, // used to determine which tab the user is on
        paymentFormType: '', // used to set the hapi iframe (card or echeck)
        savedModels: {}, // saved models for hapi iframe cache
        forceRefresh: true, // used to force refresh hapi iframes,
        selectedCard: null, // CardTypes model
        mobile: true,
        scrollError: true,
        paymentAddressDescription: {
            label: '',
        },

        deviceFingerprints: [],
        supportedCardTypesBootstrap: [],
        /*
        added this in defaults because they do not come for offline payments and hence to provide some default value
         */
        paymentFormAttributes: {
            gatewayType: '',
            countries: [],
            countryStates: {},
            countryCode: '',
            iframeUrls: {
                pan: '',
                cvn: '',
            },
            noPostalCodeChecked: false,
        },
        countryCode: appOptions.get('countryCode'), // default country code on the checkout model
        updateTotalsInProgress: false,
        isVatCodeValid: false,
        dataStorage: {},

        // saved billing address information for syncing between tabs
        savedPostalCode: null,
        savedCity: null,
        savedStreet: null,
        savedFirstName: null,
        savedLastName: null,
        savedState: null,
        stateTax: {
            CA: {
                QC: {
                    region: 'quebec',
                },
            },
        },
        companyContactForGuest: null,
        isStandaloneInterstitial: null,
    },

    url() {
        const enhancePlacementDistributionId = appOptions.get('distributionId');
        let url;

        if (utility.isVasCart()) {
            url = ckoApiCreateVasCheckout();
        } else if (utility.doesQuoteExist()) {
            url =
                `${appOptions.get(
                    'baseBizopUrl'
                )}ecomTraveler/createPaymentPage?_restfully=true` +
                `&quoteGuid=${appOptions.get(
                    'quoteGuid'
                )}&quotePaymentScheduleGuid=${appOptions.get(
                    'quotePaymentSchedule'
                )}&listingTriad=${appOptions.get(
                    'listingId'
                )}&travelerSite=${appOptions.get('site')}&site=${appOptions.get(
                    'site'
                )}&locale=${appOptions.get('locale')}&unitLink=${appOptions.get(
                    'unitLink'
                )}&travelerCountryCode=${appOptions.get('countryCode')}`;
        } else {
            url =
                `${`${appOptions.get(
                    'baseBizopUrl'
                )}createCheckoutv3Perf?_restfully=true`}&locale=${appOptions.get(
                    'locale'
                )}&arrivalDate=${appOptions.get(
                    'arrivalDate'
                )}&departureDate=${appOptions.get(
                    'departureDate'
                )}&adultsCount=${appOptions.get(
                    'adults'
                )}&childrenCount=${appOptions.get(
                    'children'
                )}&infantsCount=${appOptions.get(
                    'infants'
                )}&travelerSite=${appOptions.get('site')}&site=${appOptions.get(
                    'site'
                )}&hamorZdaEnabled=true` +
                `&petIncluded=${appOptions.get('petIncluded')}${
                    enhancePlacementDistributionId === null
                        ? ''
                        : `&placementId=${enhancePlacementDistributionId}`
                }&listingTriad=${appOptions.get('unitIdentity')}`;
            if (!_.isUndefined(appOptions.get('unitLink'))) {
                url += `&unitLink=${appOptions.get('unitLink')}`;
            }
            if (!_.isUndefined(appOptions.get('quoteGuid'))) {
                url += `&quoteGuid=${appOptions.get('quoteGuid')}`;
            }
            if (!_.isUndefined(appOptions.get('inquiryUuid'))) {
                url += `&inquiryUuid=${appOptions.get('inquiryUuid')}`;
            }
            if (!_.isUndefined(appOptions.get('ratePlanId'))) {
                url += `&ratePlanId=${appOptions.get('ratePlanId')}`;
            }
            if (!_.isUndefined(appOptions.get('roomTypeId'))) {
                url += `&roomTypeId=${appOptions.get('roomTypeId')}`;
            }
            if (this.get('countryCode')) {
                url += `&travelerCountryCode=${this.get('countryCode')}`;
            }
        }
        return url;
    },

    parse(response) {
        // Parse of model/checkout
        // skeleton json object for pdp 1.5
        const pdp = {
            productGuid: 'pdp',
            items: [],
        };

        // Load unitLink from quote if not found as a URL parameter.
        if (
            _.isUndefined(appOptions.get('unitLink')) &&
            !_.isUndefined(response.quote)
        ) {
            appOptions.set('unitLink', response.quote.unitLink);
        }

        // only evaluate CoF/RDD experiment for non IPM listings and listings with CSA PDP configured
        if (
            response.listing?.integratedPropertyManager === false &&
            Array.isArray(response.rawResponse?.offerGroups) &&
            response.rawResponse.offerGroups.length > 0 &&
            response.rawResponse.offerGroups[0]?.type ===
                constants.VAS.DAMAGE_PROTECTION
        ) {
            this.cofExperimentOn = egtnlUtil.evaluateVrboPdpWithRddVsCof();
        }

        // Handle PDP 1.5, move PDP 1.5 products into the vas section to treat items as vas products
        if (
            !_.isUndefined(response.quote) &&
            !_.isUndefined(response.quote.ownerOptedDamageProtection) &&
            this.cofExperimentOn !== 2
        ) {
            // ensure eligible products is defined in the response in case endpoint returns no vas products
            response.eligibleProducts = response.eligibleProducts || {};
            response.eligibleProducts.countries =
                response.eligibleProducts.countries || [];
            response.eligibleProducts.countries[0] =
                response.eligibleProducts.countries[0] || {};
            response.eligibleProducts.countries[0].products =
                response.eligibleProducts.countries[0].products || [];

            // port over existing rdd
            if (
                typeof response.quote.ownerOptedDamageProtection
                    .requiredProtection !== 'undefined'
            ) {
                pdp.existingRDD =
                    response.quote.ownerOptedDamageProtection.requiredProtection;
            }

            // port over traveler options
            if (
                typeof response.quote.ownerOptedDamageProtection
                    .travelerOptions !== 'undefined'
            ) {
                for (
                    let i = 0;
                    i <
                    response.quote.ownerOptedDamageProtection.travelerOptions
                        .length;
                    i++
                ) {
                    pdp.items.push(
                        response.quote.ownerOptedDamageProtection
                            .travelerOptions[i]
                    );
                }

                if (
                    this.cofExperimentOn === 1 &&
                    pdp.items.length === 3 &&
                    pdp.items[2].type === constants.VAS.COF
                ) {
                    pdp.items = pdp.items.filter(
                        (e) => e.type !== constants.VAS.RDD
                    );
                } else {
                    pdp.items = pdp.items.filter(
                        (e) => e.type !== constants.VAS.COF
                    );
                }

                response.eligibleProducts.countries[0].products.push(pdp);
            }

            // add country code
            response.eligibleProducts.countries[0].countryCode =
                appOptions.get('countryCode');
        } else {
            response.eligibleProducts = response.eligibleProducts || {};
            response.eligibleProducts.countries =
                response.eligibleProducts.countries || [];
        }

        this.setDeviceFingerprints(response);

        this.setTravelerWallet(response);

        this.setCacheTotals(response);

        response = utility.addComplianceType(response);

        // Initialize payment plan to default plan.  This attribute is used in the complete checkout handler.
        if (!response.selectedPaymentPlanId) {
            response.selectedPaymentPlanId =
                constants.FLEX_PAY.MULTIPLE_PAYMENTS;
        }

        // suppress vas products if vas interstitial is enabled
        // [CHK-891] Remove VAS from native mobile checkouts
        if (nativeUtility.shouldSuppressVasProducts()) {
            response = this.suppressVasProducts(response);
        } else {
            storage.set(constants.STORAGE.CHECKOUT_MODEL, response);
        }

        if (
            response.loggedInTravelerInfo &&
            response.loggedInTravelerInfo.email
        ) {
            // If the user is logged in determine if we need to wipe stale existing session information - VCHK-11983
            const userContactDetails = storage.get('userContactDetails');
            if (
                userContactDetails &&
                userContactDetails.email !== response.loggedInTravelerInfo.email
            ) {
                storage.clear();
            }

            analytics.genericEvent(
                'user is logged in',
                constants.EDAP_CATEGORIES.TRAVELER_WALLET
            );
        }

        return response;
    },

    /*
     Why is it not in parse ?
     because quote is not available when parse is called from vasCartController.
     For more details, read comments below (in the method)
     */
    enrichPaymentData() {
        /*
        Why is it not in parse ?
        Reason is parse gets called twice in two controllers :
        1.  checkoutController
        2.  vasCartController

        in vasCartController, we do not have quote when this is called. we rather create quote after this.
        (search for formatQuote() in vasCartController if you want to know more)
        So if we place in parse and it doesn't have quote, it will create issue. Hence had to put it in a separate method
        */
        // set payment form type to first accepted payment options type
        if (
            !_.isUndefined(this.get('quote').paymentOptions) &&
            !_.isEmpty(this.get('quote').paymentOptions.acceptedPaymentTypes)
        ) {
            this.set(
                'paymentFormType',
                this.get('quote').paymentOptions.acceptedPaymentTypes[0]
            );
            this.set(
                'paymentTabType',
                this.get('quote').paymentOptions.acceptedPaymentTypes[0]
            );

            // if we don't have any saved models for
            if (
                _.isUndefined(
                    this.get('savedModels')[this.get('paymentTabType')]
                ) ||
                this.get('forceRefresh') === true
            ) {
                let tmpSavedModels = this.get('savedModels');
                tmpSavedModels[this.get('paymentTabType')] = $.extend(
                    true,
                    {},
                    this.get('paymentFormAttributes')
                );
            }
        } else {
            // if there are no payment options, then this is an offline payment type only
            checkoutConfig.selectedPaymentType = constants.paymentTypes.OFFLINE;
            this.set('paymentFormType', constants.paymentTypes.OFFLINE);
        }

        // save copy of invoice type since paymentFormType is mutable (invoice->CARD) for traveler fee CC required flows
        if (
            !_.isUndefined(this.get('paymentFormType')) &&
            this.get('paymentFormType').toUpperCase() === 'INVOICE'
        ) {
            this.set('isInvoicePaymentFormType', true);
        }

        this.set(
            'supportedCardTypesBootstrap',
            cardType.getSupportedCardTypesBootstrap(this.get('quote'))
        );
        this.processMobilePaymentEligibility();
    },

    /**
     * Set the device fingerprint "server provided ID" in the new and legacy fields (see device-fingerprint.js). This was formerly
     * provided by AOE.
     */
    setDeviceFingerprints(response) {
        response.spid = config.deviceId;
        response.kountSessionId = config.deviceId.replace(/-/g, '');
        return response;
    },

    /**
     * cache total amount and payment requests to send to bizops
     * this is needed because we update the checkout model whenever users select vas
     */
    setCacheTotals(response) {
        let paymentRequests;
        let tfee;

        if (_.isUndefined(response.quote)) {
            return;
        }

        paymentRequests = response.quote.paymentRequests;

        if (!_.isUndefined(paymentRequests)) {
            // this is cached to send to checkout without vas purchases
            response.quote.cachedTotalAmount =
                response.quote.quoteTotals.totalAmount;
            response.quote.cachedSCFTotal =
                response.quote.quoteTotals.totalAmountWithStayCollectedFees;
            response.quote.cachedPaymentRequests = paymentRequests;
            tfee = travelerFeeHelper.get(response.quote.fees);
            if (!_.isUndefined(tfee)) {
                response.quote.cachedTravelerFee = _.cloneDeep(tfee);
            }

            utility.registerDiscountFee(response.quote.fees);
            utility.registerDiscountFee(response.quote.rentalFees);
        }
    },
    suppressVasProducts(response) {
        const clonedResponse = $.extend(true, {}, response);
        let vasProducts;
        vasProducts = _.get(
            clonedResponse,
            'eligibleProducts.countries[0].products',
            null
        );

        // filter pdp
        const vasProductsWithoutPdp = _.filter(vasProducts, (product) => {
            return product.productGuid !== 'pdp';
        });

        const vasProductsWithOnlyPdp = _.filter(vasProducts, (product) => {
            return product.productGuid === 'pdp';
        });

        if (
            _.get(clonedResponse, 'eligibleProducts.countries[0]', null) !==
            null
        ) {
            clonedResponse.eligibleProducts.countries[0].products =
                vasProductsWithoutPdp;
        }

        // checkout response without PDP
        storage.set(constants.STORAGE.CHECKOUT_MODEL, clonedResponse);

        // set checkout vas products
        if (
            vasProductsWithOnlyPdp.length > 0 &&
            _.get(clonedResponse, 'eligibleProducts.countries[0]', null) !==
                null
        ) {
            clonedResponse.eligibleProducts.countries[0].products =
                vasProductsWithOnlyPdp;
        } else {
            clonedResponse.eligibleProducts =
                clonedResponse.eligibleProducts || {};
            clonedResponse.eligibleProducts.countries = [];
        }

        clonedResponse.vasInterstitialProducts = vasProductsWithoutPdp;

        return clonedResponse;
    },

    isIPM() {
        const listingInfo = this.get('listing');
        return _.get(listingInfo, 'integratedPropertyManager', false);
    },

    isPPM() {
        const listingInfo = this.get('listing');
        return _.get(listingInfo, 'platformPropertyManager', false);
    },

    isManager() {
        const listing = this.get('listing');
        return _.has(listing, 'ownerManaged') && !listing.ownerManaged;
    },

    setTravelerWallet(response) {
        const travelerWalletInfo = response.travelerWalletInfo;
        const travelerWalletEnabled = !!travelerWalletInfo;
        if (travelerWalletEnabled) {
            if (
                travelerWalletInfo.allSavedPaymentInstrumentsCard &&
                travelerWalletInfo.allSavedPaymentInstrumentsCard.length > 0
            ) {
                travelerWalletInfo.allSavedPaymentInstrumentsCard =
                    travelerWalletInfo.allSavedPaymentInstrumentsCard.filter(
                        (item) => {
                            return item.paymentInstrumentStatus !== 'DISABLED';
                        }
                    );
                travelerWalletInfo.selectedPaymentInstrument =
                    travelerWalletInfo.allSavedPaymentInstrumentsCard[0];
            } else if (
                travelerWalletInfo.lastSavedPaymentInstrument &&
                travelerWalletInfo.lastSavedPaymentInstrument
                    .paymentInstrumentStatus !== 'DISABLED'
            ) {
                travelerWalletInfo.allSavedPaymentInstrumentsCard = [
                    travelerWalletInfo.lastSavedPaymentInstrument,
                ];
                travelerWalletInfo.selectedPaymentInstrument =
                    travelerWalletInfo.lastSavedPaymentInstrument;
            } else {
                travelerWalletInfo.allSavedPaymentInstrumentsCard = null;
                travelerWalletInfo.selectedPaymentInstrument = null;
            }
            travelerWalletInfo.lastSavedPaymentInstrument = null;
        }
        response.travelerWalletInfo = travelerWalletInfo || {};
    },

    getPaymentRequest(paymentNumber) {
        if (
            _.isArray(this.get('quote').paymentRequests) &&
            this.get('quote').paymentRequests.length >= paymentNumber
        ) {
            return _.find(
                this.get('quote').paymentRequests,
                (paymentRequest) => {
                    return paymentRequest.paymentNumber === paymentNumber;
                }
            );
        }

        return null;
    },

    getCurrencyCode() {
        if (_.isString(this.get('quote').currencyCode)) {
            return this.get('quote').currencyCode;
        } else if (!_.isEmpty(this.get('quote').paymentRequests)) {
            return this.get('quote').paymentRequests[0].amountForOwner
                .currencyCode;
        }

        return null;
    },

    getAcceptedPaymentTypes() {
        // because applepay is stripped out, we still need a place where we remove applePay
        // from acceptedPaymentTypes this seemed like the most direct, obvious, and sensible place
        return _.get(
            this.get('quote'),
            'paymentOptions.acceptedPaymentTypes',
            []
        ).filter((type) => type !== constants.mobilePaymentTypes.APPLE_PAY);
    },

    /**
     * Checks if the payment mode is an Offline Payment mode (OFFLINE or ONLINE_OR_OFFLINE)
     * @returns {boolean}
     */
    hasOfflinePaymentMethodsEnabled() {
        return _.includes(
            [
                constants.offlinePaymentModes.OFFLINE,
                constants.offlinePaymentModes.ONLINE_OR_OFFLINE,
            ],
            this.get('offlinePaymentMode')
        );
    },

    /**
     * Checks if payments are IPM Deferred or Invoicing flows and if Traveler Fee is present
     */
    isDeferredPaymentWithoutCCRequired() {
        return (
            this.isDeferredPayment() &&
            !travelerFeeHelper.has(this.get('quote').fees)
        );
    },

    isDeferredPaymentWithCCRequired() {
        return (
            this.isDeferredPayment() &&
            travelerFeeHelper.has(this.get('quote').fees)
        );
    },

    isInvoicePaymentWithoutCCRequired() {
        return (
            (this.isInvoicePaymentFormType() ||
                this.isInvoiceAcceptedPaymentType()) &&
            !travelerFeeHelper.has(this.get('quote').fees)
        );
    },

    isInvoicePaymentWithCCRequired() {
        return (
            (this.isInvoicePaymentFormType() ||
                this.isInvoiceAcceptedPaymentType()) &&
            travelerFeeHelper.has(this.get('quote').fees)
        );
    },

    isDeferredPayment() {
        const paymentCollectionType = _.get(
            this.get('quote'),
            'paymentOptions.paymentCollectionType',
            ''
        );
        return (
            _.isString(paymentCollectionType) &&
            paymentCollectionType === constants.paymentFormTypes.DEFERRED
        );
    },

    isInvoicePaymentFormType() {
        return (
            !_.isUndefined(this.get('isInvoicePaymentFormType')) &&
            this.get('isInvoicePaymentFormType')
        );
    },

    isInvoiceAcceptedPaymentType() {
        return (
            !_.isUndefined(this.get('quote').paymentOptions) &&
            !_.isUndefined(
                this.get('quote').paymentOptions.acceptedPaymentTypes
            ) &&
            _.includes(
                this.get('quote').paymentOptions.acceptedPaymentTypes,
                'INVOICE'
            )
        );
    },

    isOfflineOnly() {
        return (
            this.get('offlinePaymentMode') ===
            constants.offlinePaymentModes.OFFLINE
        );
    },

    /**
     * Checks if the payment mode is an ONLINE Payment mode (ONLINE)
     * @returns {boolean}
     */
    hasOnlinePaymentMethodsEnabled() {
        return _.includes(
            [
                constants.offlinePaymentModes.ONLINE,
                constants.offlinePaymentModes.ONLINE_OR_OFFLINE,
            ],
            this.get('offlinePaymentMode')
        );
    },

    /**
     * Returns the index of the offline payment method from within the payment method array in the Offline
     * Payment Method collection
     * @param offlinePaymentMethod
     * @returns number: index of found payment method, else -1
     */
    getOfflinePaymentMethodIndex(offlinePaymentMethod) {
        let i;

        for (
            i = 0;
            i <
            this.get('offlinePaymentMethodCollection').paymentMethods.length;
            ++i
        ) {
            if (
                this.get('offlinePaymentMethodCollection').paymentMethods[i]
                    .link === offlinePaymentMethod
            ) {
                return i;
            }
        }

        return -1;
    },

    getOfflinePaymentMethodByLink(paymentMethodLink) {
        if (!_.isUndefined(this.get('offlinePaymentMethodCollection'))) {
            return _.find(
                this.get('offlinePaymentMethodCollection').paymentMethods,
                (paymentMethod) => {
                    return paymentMethod.link === paymentMethodLink;
                }
            );
        }
        return null;
    },

    /**
     * @param userVasDetails {Object}   The user VAS details model.
     * @param paidOrderItems {String[]} The list of paid traveler order items.
     * @returns {boolean} true if a credit card payment is required for this off-platform payment, false otherwise.
     *          Credit card payment is required for VAS and the traveler service fee.
     */
    isCreditCardRequiredForOffPlatformPayment(userVasDetails, paidOrderItems) {
        let vasOptionsSelected =
            vasHelper.hasVasOptionsSelected(userVasDetails);
        let travelerFeeRequiresPayment = _.isObject(
            travelerFeeHelper.getIfUnpaid(
                this.get('quote').fees,
                paidOrderItems
            )
        );

        return vasOptionsSelected || travelerFeeRequiresPayment;
    },

    /**
     * This is an Offline Payment only listing where Traveler is required to pay services/fees with credit card if
     *     1. Offline Payments are enabled
     *     2. Online Payments are not enabled
     *     3. Traveler has selected at least one VAS product OR Listing has Traveler Fee which has not yet been paid.
     * @param userVasDetails {Object}   User Vas Details Model
     * @param paidOrderItems {String[]} The list of paid traveler order items.
     * @returns {*|boolean}
     */
    isOfflinePayOnlyWithCreditCardNeeded(userVasDetails, paidOrderItems) {
        let strictlyOfflinePaymentMethods =
            this.hasOfflinePaymentMethodsEnabled() &&
            !this.hasOnlinePaymentMethodsEnabled();

        return (
            strictlyOfflinePaymentMethods &&
            this.isCreditCardRequiredForOffPlatformPayment(
                userVasDetails,
                paidOrderItems
            )
        );
    },

    processMobilePaymentEligibility() {
        const acceptedPaymentTypes =
            this.get('quote').paymentOptions.acceptedPaymentTypes || [];
        const mobileIndex = acceptedPaymentTypes.indexOf(
            constants.paymentFormTypes.MOBILE
        );
        const eligible = mobileIndex !== -1;

        if (eligible) {
            // remove MOBILE from acceptedPaymentTypes
            // (no apple or android payment options supported at this time,
            // but when they are, we sub MOBILE for the appropriate type)
            // ** MOBILE may not ever be a valid value, based on the fact that ApplePay comes
            // into the web view automatically, and not MOBILE
            acceptedPaymentTypes.splice(mobileIndex, 1);
        }
    },

    isPayPalCheckout() {
        return (
            this.get('paymentFormType') ===
            constants.paymentFormTypes.PAYPAL_ONLINE
        );
    },

    isPayPalAllowed() {
        return this.getAcceptedPaymentTypes().includes(
            constants.paymentFormTypes.PAYPAL_ONLINE
        );
    },

    isAffirmCheckout() {
        return (
            this.get('paymentFormType') === constants.paymentFormTypes.AFFIRM
        );
    },

    isAffirmAllowed() {
        return (
            window.affirm &&
            this.getAcceptedPaymentTypes().includes(
                constants.paymentFormTypes.AFFIRM
            ) &&
            !this.isIPM()
        );
    },

    isBrazilPOS() {
        return (
            this.get('countryCode') === constants.COUNTRY_CODES.BR &&
            appOptions.get('brandId') === constants.BRAND_IDS.HOMEAWAY_BR
        );
    },

    getPaymentInstallments() {
        return (
            this.isBrazilPOS() &&
            _.get(this.get('quote'), 'paymentRequests[0].installmentOptions')
        );
    },
});

export default checkoutModel;
